"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useApp = exports.default = exports.GRAPH_ID = exports.CorrectTabKey2 = exports.CorrectTabKey = exports.AppContext = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("../../services/core");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const AppContext = exports.AppContext = /*#__PURE__*/_react.default.createContext();

// -------- UTILISATION DU CONTEXT ---------
//
// import { useApp } from '@/contexts/app/main
// const [elements, dispatcher] = useApp();
const useApp = () => (0, _react.useContext)(AppContext);

// -------- CLES PERMETTANT LA MISE A JOUR DE VOS DONNEES ------
exports.useApp = useApp;
const CorrectTabKey = exports.CorrectTabKey = 'la_cle_du_tableau_correct';
const CorrectTabKey2 = exports.CorrectTabKey2 = 'la_cle_du_tableau_correct2';
const GRAPH_ID = exports.GRAPH_ID = 'graphId';

/* ====================================
 * Ce fichier est pour votre application, modifiez le à votre souhait.
 * ====================================== */

// exemples d'utilisation
const appReducer = (state, action) => {
  switch (action.type) {
    case CorrectTabKey:
    case CorrectTabKey2:
      return {
        ...state,
        [action.type]: action.value
      };
    default:
      return state;
  }
};

// Votre context principal
const AppProvider = _ref => {
  let {
    children /* vos props, exemple : graphId */
  } = _ref;
  const [appValues, dispatch] = (0, _react.useReducer)(appReducer, {
    loading: false,
    la_cle_du_tableau_correct: null
  });

  /* a importer en haut si besoin : exemple : initialisation des props dans votre reducer
    useEffect(() => {
        // exemple
        if (!graphId) {
            notifier.success(t('error'), t('error_occurred'));
            return;
        }
         dispatch({type: GRAPH_ID, value: graphId })
    }, []);
    */

  if (!appValues || appValues.loading) {
    return /*#__PURE__*/_react.default.createElement("div", null, (0, _core._translate)('loading'), "...");
  }
  return /*#__PURE__*/_react.default.createElement(AppContext.Provider, {
    value: [appValues, dispatch]
  }, children);
};
AppProvider.propTypes = {
  children: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.elementType])
};
AppProvider.defaultProps = {
  children: null
};
var _default = exports.default = AppProvider;